import { ActionIcon, Button, Stack, Tooltip } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
import { useLanguage } from "../../../../stores/LanguageStore";
import ItemDeleter from "../../../../components/TableComponents/ItemDeleter";
import ItemSharer from "../../../../components/TableComponents/ItemSharer";
import {
  deleteLinkedinAccount,
  editLinkedinAccount,
} from "../../../../api/EmailAPI";
import PopOver from "../../../../components/View/PopOver";

const LinkedinAccountActions = ({ current, inside = false, onFinish }) => {
  const lang = useLanguage((s) => s.language);

  return (
    <PopOver
      opener={(handleOpen, ref) =>
        inside ? (
          <Button
            ref={ref}
            variant="light"
            color="primary"
            leftSection={<IconDotsVertical size={18} />}
            radius={"sm"}
            ml={"auto"}
            onClick={handleOpen}
          >
            {lang.table.more_actions}
          </Button>
        ) : (
          <Tooltip label={lang.table.more_actions}>
            <ActionIcon
              variant="subtle"
              ref={ref}
              color="primary"
              onClick={handleOpen}
            >
              <IconDotsVertical size={18} />
            </ActionIcon>
          </Tooltip>
        )
      }
      popoverChildren={(handleClose) => (
        <Stack gap={"sm"}>
          <ItemSharer
            current={current}
            handleShare={editLinkedinAccount}
            onFinish={onFinish}
          />

          <ItemDeleter
            title_bold={`${current.name} #${current.id}`}
            handleDelete={deleteLinkedinAccount}
            deletedMessage={lang.linkedin_accounts.delete_success}
            id={current.id}
            disabled={
              !current?.delete_permission &&
              !current?.permission?.delete_permission
            }
            onFinish={onFinish}
            isButton
          />
        </Stack>
      )}
      anchorOrigin={
        inside
          ? { horizontal: "right", vertical: "bottom" }
          : { horizontal: "left", vertical: "center" }
      }
      transformOrigin={
        inside
          ? { horizontal: "right", vertical: "top" }
          : { horizontal: "right", vertical: "center" }
      }
      sx={{ zIndex: "100 !important" }}
    />
  );
};

export default LinkedinAccountActions;
